<script setup></script>

<template>
  <div class="message-container">
    <div class="role-image">W</div>

    <div class="text-loading">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

@keyframes skeleton-loading {
  0% {
    background-color: hsl(200, 20%, 60%);
  }
  100% {
    background-color: hsl(200, 20%, 80%);
  }
}

.message-container {
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 100%;

  > .role-image {
    width: 24px;
    height: 24px;
    border-radius: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    flex-shrink: 0;
    background: colors.$light-blue-color;
    color: colors.$white-color;
    font-weight: bold;
  }

  > .text-loading {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;

    > div {
      height: 8px;
      background: grey;
      animation: skeleton-loading 1s linear infinite alternate;
    }

    > div:nth-child(1) {
      width: 100%;
    }

    > div:nth-child(2) {
      width: 80%;
      animation-delay: 200ms;
    }

    > div:nth-child(3) {
      width: 60%;
      animation-delay: 400ms;
    }
  }
}
</style>
